export const webColor = {
  bgPrimary: '#160000',
  seat: {
    regular: {
      border: '1px solid #01c73c',
      cursor: 'pointer',
    },
    vip: {
      border: '1px solid #f71708',
      cursor: 'pointer',
    },
    booked: {
      border: '1px solid #bbb',
      background: '#bbb',
    },
    selected: {
      border: '1px solid #b11500',
      background: '#b11500',
      cursor: 'pointer',
    },
  },
  spinnerPrimary: '#e53e3e',
};
